// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__I1yJn","colCheckbox":"styles_colCheckbox__BlgQS"};